"use client";

import { Input } from "@/components/rac/input";
import { Label } from "@/components/rac/label";
import { useAuth } from "@/hooks/use-auth";
import { useState } from "react";

const defaultError = { name: "", email: "" };

interface EmailSubmissionProps {
	name?: string;
	email?: string;
	setName: (name: string) => void;
	setEmail: (email: string) => void;
}

export function EmailSubmission({ name, email, setName, setEmail }: EmailSubmissionProps) {
	const { user } = useAuth();
	const userName = user?.name;
	const [error, setError] = useState(defaultError);

	const hasValidUserName = userName && userName !== "<No Name>" && userName.trim() !== "";
	const showNameField = !hasValidUserName;

	return (
		<div className="space-y-1">
			<div className="space-y-4">
				{showNameField && (
					<div className="space-y-2">
						<Label htmlFor="name" className="text-sm font-medium text-gray-700">
							Name
						</Label>
						<Input
							id="name"
							type="text"
							placeholder="Enter your name"
							value={name || ""}
							onChange={e => {
								setName(e.target.value);
								if (error.name) setError({ ...error, name: "" });
							}}
							className="w-full"
						/>
						{error.name && <p className="text-sm text-red-600">{error.name}</p>}
					</div>
				)}
				<div className="space-y-2">
					<Label htmlFor="email" className="text-sm font-medium text-gray-700">
						Email Address
					</Label>
					<Input
						id="email"
						type="email"
						placeholder="Enter your email address"
						value={email || ""}
						onChange={e => {
							setEmail(e.target.value);
							if (error.email) setError({ ...error, email: "" });
						}}
						className="w-full"
					/>
					{error.email && <p className="text-sm text-red-600">{error.email}</p>}
				</div>
			</div>
		</div>
	);
}
